import React from "react";

/** Reusable COMING SOON block for phases not yet built. */
export function ComingSoon({ title, description, icon: Icon, phase }) {
  return (
    <div data-testid="coming-soon" className="animate-fade-up mx-auto max-w-2xl px-6 py-16 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-accent text-primary">
        {Icon ? <Icon size={30} weight="duotone" /> : null}
      </div>
      <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
        Coming Soon{phase ? ` · ${phase}` : ""}
      </div>
      <h1 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
      <p className="mx-auto mt-4 max-w-md text-muted-foreground">{description}</p>
      <p className="mx-auto mt-6 max-w-md text-xs text-muted-foreground/70">
        The infrastructure is provisioned in the backend. This experience activates in an upcoming build phase.
      </p>
    </div>
  );
}
